export function getDiscountName(name) {
  return name || '[Payor discount]'
}
